export enum WebSocketOutputTypes {
  CONNECTED = 'CONNECTED',
  ERROR = 'ERROR',
  DISCONNECTED = 'DISCONNECTED',
  GEM_MEDIA_ZIPPED = 'gem-media-zipped',
  GEM_PASSPORT_GENERATED = 'gem-passport-generated',
  GEM_AI_STATUS = 'gem-ai-status',
}
